import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { FunctionComponent } from 'react';

import {
  FolkloreType,
  TargetedUsersQuery,
} from '../../../../../apollo/__generated__/graphql';
import { folkloreNameByFolklore } from '../../../../../user/services/user.service';
import { useTargetedUsersQuery } from '../../../../hooks/useTargetedUsersQuery';

interface TargetedUsersTabProps {
  eventId: string;
}

const columns: GridColDef<TargetedUsersQuery['targetedUsers'][number]>[] = [
  {
    field: 'targetCount',
    headerName: 'Targets',
  },
  {
    field: 'firstname',
    headerName: 'Nom',
    width: 150,
    renderCell: (params) =>
      `${params.row.firstname} ${params.row.lastname?.substring(0, 1)}.`,
  },
  {
    field: 'nickname',
    headerName: 'Surnom',
    width: 150,
  },
  {
    field: 'folklore',
    headerName: 'Folklore',
    renderCell: (params) =>
      folkloreNameByFolklore[params.row.folklore ?? FolkloreType.Other],
    width: 100,
  },
  {
    field: 'studyTown',
    headerName: 'Ville',
    width: 150,
  },
  {
    field: 'studies',
    headerName: 'Fillière',
    width: 150,
  },
];

export const TargetedUsersTab: FunctionComponent<TargetedUsersTabProps> = ({
  eventId,
}) => {
  const { data: userTargetsData, loading } = useTargetedUsersQuery(eventId);

  return (
    <DataGrid
      rows={userTargetsData?.targetedUsers ?? []}
      columns={columns}
      loading={loading}
    />
  );
};
